export default {
  api_r_user_module_survey_getModuleData: {
    path: 'm/survey/get-module-data/',
  },
  api_r_user_module_survey_getPermissions: {
    path: 'm/survey/get-permissions/',
  },
  api_r_user_module_survey_get: {
    path: 'm/survey/get/',
  },
  api_r_user_module_survey_edit: {
    path: 'm/survey/edit/',
  },
  api_r_user_module_survey_start: {
    path: 'm/survey/start/',
  },
  api_r_user_module_survey_end: {
    path: 'm/survey/end/',
  },
};
